"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCodes = {
    ACCOUNT_DISABLED: 'ACCOUNT_DISABLED',
    AUTHORIZATION_REQUIRED: 'AUTHORIZATION_REQUIRED',
    FILE_TYPE_NOT_ALLOWED: 'FILE_TYPE_NOT_ALLOWED',
    FILE_NOT_FOUND: 'FILE_NOT_FOUND',
    FILE_USED: 'FILE_USED',
    FORBIDDEN: 'FORBIDDEN',
    IMAGE_NOT_FOUND: 'IMAGE_NOT_FOUND',
    INVALID_ACTION_TYPE: 'INVALID_ACTION_TYPE',
    INVALID_CUSTOMER_ROLE: 'INVALID_CUSTOMER_ROLE',
    INVALID_IMAGE: 'INVALID_IMAGE',
    INVALID_ROLE: 'INVALID_ROLE',
    INVALID_STATUS_RESPONSE: 'INVALID_STATUS_RESPONSE',
    ITEM_NOT_FOUND: 'ITEM_NOT_FOUND',
    MEMBER_NOT_FOUND: 'MEMBER_NOT_FOUND',
    MEMO_ALREADY_ACTIONED: 'MEMO_ALREADY_ACTIONED',
    MEMO_CATEGORY_NOT_FOUND: 'MEMO_CATEGORY_NOT_FOUND',
    ORGANISATION_DISABLED: 'ORGANISATION_DISABLED',
    PERMISSION_EXISTS: 'PERMISSION_EXISTS',
    PERMISSION_REQUESTED: 'PERMISSION_REQUESTED',
    REQUEST_NOT_FOUND: 'REQUEST_NOT_FOUND',
    REQUEST_TOO_LARGE: 'REQUEST_TOO_LARGE',
    RESPONSE_ALREADY_GIVEN: 'RESPONSE_ALREADY_GIVEN'
};
//# sourceMappingURL=error-codes.js.map